import React from 'react';
import { useStore } from '../../store/useStore';
import { LayoutDashboard, List, ShoppingBag, Settings as SettingsIcon, CheckCircle2 } from 'lucide-react';
import { Overview } from './Overview';
import { Menu } from './Menu';
import { Orders } from './Orders';
import { Settings } from './Settings';
import { clsx } from 'clsx';
export function DispensaryApp() {
  const {
    businessCurrentView,
    setBusinessView
  } = useStore();
  const navItems = [{
    id: 'Overview',
    label: 'Overview',
    icon: LayoutDashboard
  }, {
    id: 'Menu',
    label: 'Menu',
    icon: List
  }, {
    id: 'Orders',
    label: 'Orders',
    icon: ShoppingBag
  }, {
    id: 'Settings',
    label: 'Settings',
    icon: SettingsIcon
  }] as const;
  return <div className="h-full flex bg-[#F4F5F6]" data-id="element-12">
      {/* Sidebar */}
      <div className="w-64 bg-white border-r border-[rgba(37,41,53,0.12)] flex flex-col" data-id="element-13">
        <div className="p-6 border-b border-[rgba(37,41,53,0.12)]" data-id="element-14">
          <h2 className="text-xl font-bold text-[#252935] mb-2" data-id="element-15">Green Cross</h2>
          <div className="inline-flex items-center gap-1.5 bg-[#E9FAF8] text-[#007E7A] px-2.5 py-1 rounded-full text-xs font-bold uppercase tracking-wider" data-id="element-16">
            <CheckCircle2 className="w-3.5 h-3.5" data-id="element-17" />
            Stash Active
          </div>
        </div>
        <nav className="flex-1 p-4 space-y-1" data-id="element-18">
          {navItems.map(item => {
          const Icon = item.icon;
          const isActive = businessCurrentView === item.id;
          return <button key={item.id} onClick={() => setBusinessView(item.id)} className={clsx('w-full flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium transition-colors', isActive ? 'bg-[#E9FAF8] text-[#007E7A]' : 'text-[#60646F] hover:bg-gray-50 hover:text-[#252935]')} data-id="element-19">
                <Icon className="w-5 h-5" data-id="element-20" />
                {item.label}
              </button>;
        })}
        </nav>
      </div>

      {/* Main Content */}
      <div className="flex-1 overflow-y-auto p-8" data-id="element-21">
        {businessCurrentView === 'Overview' && <Overview data-id="element-22" />}
        {businessCurrentView === 'Menu' && <Menu data-id="element-23" />}
        {businessCurrentView === 'Orders' && <Orders data-id="element-24" />}
        {businessCurrentView === 'Settings' && <Settings data-id="element-25" />}
      </div>
    </div>;
}